module.exports = __webpack_public_path__ + "img/logo.ee7b0fad.png";